import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Users, MapPin } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden" data-id="element-76">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-77">
        <div className="flex flex-col gap-12 lg:gap-16" data-id="element-78">
          {/* Full-width Banner */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="w-full relative" data-id="element-79">
            <div className="relative rounded-2xl overflow-hidden shadow-soft-lg aspect-[16/9] md:aspect-[2/1]" data-id="element-80">
              <div className="absolute inset-0 bg-gradient-to-tr from-charcoal/10 to-transparent z-10 mix-blend-overlay" data-id="element-81"></div>
              <img src="https://cdn.magicpatterns.com/uploads/oyZts3EGERwWSXRHbuDn4o/Banner_Profesional.png" alt="Médicas de Mantra Medicina Estética junto al logo de la clínica" className="w-full h-full object-cover object-center" data-id="element-82" />
            </div>
          </motion.div>

          {/* Content below banner */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="max-w-3xl mx-auto text-center z-10" data-id="element-83">
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-charcoal leading-[1.1] mb-6" data-id="element-84">
              Tu mejor versión, respaldada por ciencia médica.
            </h1>
            <p className="text-charcoal/70 text-lg md:text-xl leading-relaxed mb-10 font-light" data-id="element-85">
              Medicina estética avanzada en Montevideo. Tratamientos con láser,
              botox, PRP y más — diseñados por médicas especializadas para
              resultados naturales y duraderos.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16" data-id="element-86">
              <a href="#reservar" className="bg-rosegold text-white px-8 py-4 rounded-full text-center font-medium hover:bg-rosegold-600 transition-all shadow-soft-lg hover:shadow-none" data-id="element-87">
                Reservar mi consulta
              </a>
              <a href="#tratamientos" className="border border-charcoal/20 text-charcoal px-8 py-4 rounded-full text-center font-medium hover:bg-charcoal hover:text-white transition-all" data-id="element-88">
                Ver tratamientos
              </a>
            </div>

            {/* Trust Bar */}
            <div className="flex flex-col sm:flex-row gap-6 sm:gap-8 justify-center items-center pt-8 border-t border-rosegold/20" data-id="element-89">
              <div className="flex items-center gap-3" data-id="element-90">
                <div className="bg-sage/10 p-2 rounded-full text-sage" data-id="element-91">
                  <ShieldCheck size={20} data-id="element-92" />
                </div>
                <span className="text-sm font-medium text-charcoal/80" data-id="element-93">
                  +10 años de experiencia médica
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-94">
                <div className="bg-sage/10 p-2 rounded-full text-sage" data-id="element-95">
                  <Users size={20} data-id="element-96" />
                </div>
                <span className="text-sm font-medium text-charcoal/80" data-id="element-97">
                  +5.000 pacientes tratadas
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-98">
                <div className="bg-rosegold/10 p-2 rounded-full text-rosegold" data-id="element-99">
                  <MapPin size={20} data-id="element-100" />
                </div>
                <span className="text-sm font-medium text-charcoal/80" data-id="element-101">
                  Montevideo | PdE | Piriápolis | San José | Colonia
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}